import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Controller, useFormContext } from 'react-hook-form';

import { Select } from '@/components/common';
import { planBuilderConstants } from '@/modules/AdminTools/lib/constants';

import { salesSettingsByAreaSelector } from '@/modules/AdminTools/redux/planBuilder/can-edit-settings/sales-settings';
import { selectAreasList } from '@/redux/areas-new';

const { AREA_LABEL, TARGET_ID_VALUE } = planBuilderConstants;

const AreaSelect = () => {
  const areas = useSelector(selectAreasList);
  const salesSettingsByArea = useSelector(salesSettingsByAreaSelector);

  const { control } = useFormContext();

  const options = useMemo(() => {
    if (!areas) {
      return [];
    }
    const areaIds = salesSettingsByArea.map(({ [TARGET_ID_VALUE]:target_id }) => target_id);

    const values = areas
      .filter(({ area_id }) => !areaIds.includes(area_id))
      .map(({ area_id, area_name }) => ({
        label: area_name,
        value: area_id,
      }));

    return values;
  }, [areas, salesSettingsByArea]);

  return (
    <div className="flex flex-col w-64">
      <div className="flex items-center">
        <div className="flex text-sm font-medium text-gray-700">
          <label>
            {AREA_LABEL}
            <span className="text-red-500 pl-1">{'*'}</span>
          </label>
        </div>
      </div>
      <div className="mt-0.5 block rounded-md shadow-sm">
        <Controller
          control={control}
          name={TARGET_ID_VALUE}
          render={({ field: { onChange, onBlur, value, ref, name } }) => (
            <Select
              {...{
                name,
                onChange,
                onBlur,
                value,
                ref,
                options,
                required:true,
                placeholder:'Select an Area',
              }}
            />
          )}
        />
      </div>
    </div>
  );
};

export default AreaSelect;
